
let cached: boolean | null = null;

const SOFTWARE_RENDERER_MARKERS = [
  "swiftshader",
  "software",
  "llvmpipe",
  "microsoft basic render",
  "google, swiftshader",
];

export function canRenderHeavyWebgl(): boolean {
  if (cached !== null) return cached;
  if (typeof window === "undefined") return false;

  try {
    const canvas = document.createElement("canvas");
    const gl = (canvas.getContext("webgl") ||
      canvas.getContext("experimental-webgl")) as WebGLRenderingContext | null;
    if (!gl) {
      cached = false;
      return cached;
    }

    const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    if (debugInfo) {
      const renderer = String(
        gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL) || ""
      ).toLowerCase();
      if (SOFTWARE_RENDERER_MARKERS.some((m) => renderer.includes(m))) {
        // Explicitly a software rasterizer — running the scenes here would saturate the CPU.
        cached = false;
        return cached;
      }
    }

    cached = true;
    return cached;
  } catch {
    cached = false;
    return cached;
  }
}
